import { render, staticRenderFns } from "./Storelist.vue?vue&type=template&id=1b4981fa&scoped=true"
import script from "./Storelist.vue?vue&type=script&lang=js"
export * from "./Storelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4981fa",
  null
  
)

export default component.exports